import { render, staticRenderFns } from "./Papers.vue?vue&type=template&id=c7c75fce&scoped=true"
import script from "./Papers.vue?vue&type=script&lang=js"
export * from "./Papers.vue?vue&type=script&lang=js"
import style0 from "./Papers.vue?vue&type=style&index=0&id=c7c75fce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c75fce",
  null
  
)

export default component.exports